import Vue from 'vue'

//not-images
import not_imageBanner from '../components/not_images/not_imageBanner'
import not_imageShow from '../components/not_images/not_imageShow'
import not_imageCrop from '../components/not_images/imageCrop'

import not_googleMap from '../components/not_maps/not_googleMap'
import not_mapBox from '../components/not_maps/not_mapBox'

import not_footer from '../components/not_sections/not_footer'
import not_header from '../components/not_sections/not_header'
import not_page_spinner from '../components/not_sections/not_page_spinner'

import not_banner from '../components/not_toolbars/not_banner'
import not_banner_donation from '../components/not_toolbars/not_banner_donation'
import not_navbar from '../components/not_toolbars/not_navbar'
import not_toolbar from '../components/not_toolbars/not_toolbar'
import not_cpanel_tab from '../components/not_toolbars/not_cpanel_tab'

import not_dialog from '../components/not_menus/not_dialog'
import not_dialogProgress from '../components/not_menus/not_dialogProgress'

//not-file-selecter
import excelSelecter from "../components/not_file_selecter/excelSelecter"
 



//not-images
Vue.component('not-image-banner', not_imageBanner)
Vue.component('not-image-show', not_imageShow) 
Vue.component('not-image-crop', not_imageCrop) 

Vue.component('not-map-google', not_googleMap)
Vue.component('not-map-box', not_mapBox)

Vue.component('not-footer', not_footer)
Vue.component('not-header', not_header)
Vue.component('not-page-spinner', not_page_spinner)

Vue.component('not-banner', not_banner)
Vue.component('not-banner-donation', not_banner_donation)
Vue.component('not-navbar', not_navbar)
Vue.component('not-toolbar', not_toolbar) 
Vue.component('not-cpanel-tab', not_cpanel_tab) 

Vue.component('not-dialog', not_dialog) 
Vue.component('not-dialog-p', not_dialogProgress) 
//not-file-selecter
Vue.component('not-selecter-excel',excelSelecter)